import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import DescriptionIcon from '@mui/icons-material/Description';

import {
/*   Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, 
  Paper,*/
  Dialog,DialogTitle, DialogContent, ListItemText,DialogActions,Button, ListItemAvatar,Avatar,
   Typography, List, ListItem, Box, Badge  
} from "@mui/material/";

import FormJaivana from 'dashboard_jaivana_v1';
/* import { PickersDay } from '@mui/x-date-pickers/PickersDay'; */

dayjs.locale('es');

/**
 * @description Calendario implementado con el componente DateCalendar de React
 * @author Juan Camilo Villa 
 * @version jdesk_1.01.0001.1
 **/


class CustomCalendario extends FormJaivana.form {
constructor(props){
    super(props);
    this.refs = React.createRef();
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChangeBigCalendar = this.handleDateChangeBigCalendar.bind(this);
    this.sendService = this.sendService.bind(this);
    this.success = this.success.bind(this);
    this.getEventByDate = this.getEventByDate.bind(this);
    this.successByDate = this.successByDate.bind(this);
    this.error = this.error.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleOpenDialog = this.handleOpenDialog.bind(this);

    this.state = {
      selectedDate: dayjs(),
      arrayEvents: [],
      arrayNewEvents: [],
      objectEventSelected: {},
      openDialog: false,
      selectedEventItems:[],
    };
  }
  componentDidMount() {

    console.log('Formulario: Calendario,  @version: jdesk_1.01.0001.1, @author: Juan Camilo Villa');
    this.handleDateChange(dayjs());
  }

  sendService = (fechaRecibida) => {

    let datos={datos:{fecha: fechaRecibida}}
    try {
      this.generalFormatPmv = { tipo_servicio: 'heus-calendario', operacion: 'getDocumentosRecibidos', operacion_tipo: 'consulta' };
      this.service.send(
      {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.success,
        error: this.error,
        general: this.generalFormatPmv,
        showMessage: false
      });

    } catch (error) {
     
      
    }
  }
  ///Obtiene todos los eventos dada la fecha
  getEventByDate = (fechaRecibida) => {
    if (typeof fechaRecibida !== undefined || fechaRecibida !== null || fechaRecibida !== '') {
      
      let datos={datos:{fecha: fechaRecibida}}
      try {
        this.generalFormatPmv = { tipo_servicio: 'heus-calendario', operacion: 'getDocumentosRecibidosPorFecha', operacion_tipo: 'consulta' };
        this.service.send(
          {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successByDate,
            error: this.error,
            general: this.generalFormatPmv,
            showMessage: false
          });
          
        } catch (error) {
          
          
        }
      }
  }

  success = (data) => {
    if (data.estado_p === 200) {
      let eventFind = {};
      
      let arrayEvents = structuredClone(data.data);
      
      let arrayNewEvents = arrayEvents.flatMap((document) => {
        return [
          { date: document.vence_documento, title: 'Cantidad: ' + document.cantidad_registros, color: '#1976D2'},
/*           { date: document.vence_documento, title: 'Impuesto: ' + document.total_con_impuesto, color: '#1976D2'},
          { date: document.vence_documento, title: 'Sin Impuesto: ' + document.total_sin_impuesto, color: '#1976D2'}, */
        ];
      });

      eventFind = arrayEvents.find(event => {
      const fechaselected = new Date(event.vence_documento + 'T00:00:00');
      const fechaEvent = new Date(this.state.selectedDate.format('YYYY-MM-DD') + 'T00:00:00');
      return (fechaselected.getFullYear() === fechaEvent.getFullYear() &&
        fechaselected.getMonth() === fechaEvent.getMonth() &&
        fechaselected.getDate() === fechaEvent.getDate()
      ) 
    }) ?? {};


    
    this.setState({
      arrayEvents: arrayEvents,
      arrayNewEvents: arrayNewEvents,
      objectEventSelected: eventFind,
    });
    if(Object.keys(eventFind).length > 0) this.getEventByDate(eventFind.vence_documento);
    
    
    
    }
  }
  successByDate = (data) => {
   
    let arrayEventsSelected = [];     
    if (data.estado_p === 200) {
      arrayEventsSelected = structuredClone(data.data); 
      /* this.handleOpenDialog(arrayEventsSelected); */
      
    } 
    this.setState({
      selectedEventItems : arrayEventsSelected,
      /* openDialog: true */
    });
  }

  error = (e)=>{}



///Calendario pequeño
  handleDateChange = (newDate) => {
    this.setState({ selectedDate: newDate });

    this.setState({ 
        selectedDate: newDate,
      });
    this.sendService(newDate.format('YYYY-MM-DD'));
  };

  handleDateChangeBigCalendar = (newDate) => {
    /* let date = newDate.format('YYYY-MM-DD'); */
    this.setState({ selectedDate: newDate });

    this.setState({ 
        selectedDate: newDate,
      });

/*     const eventSelected = this.state.arrayNewEvents.filter((e) =>
      newDate.isSame(e.date, 'day')
    ) ?? {}; */

     let eventFind = this.state.arrayEvents.find(event => {
      const fechaselected = new Date(event.vence_documento + 'T00:00:00');
      const fechaEvent = new Date(newDate.format('YYYY-MM-DD') + 'T00:00:00');
      return (fechaselected.getFullYear() === fechaEvent.getFullYear() &&
        fechaselected.getMonth() === fechaEvent.getMonth() &&
        fechaselected.getDate() === fechaEvent.getDate()
      ) 
    }) ?? {};

    if(Object.keys(eventFind).length > 0) this.getEventByDate(eventFind.vence_documento);
      
      this.setState({
/*         arrayEvents: arrayEvents,
        arrayNewEvents: arrayNewEvents, */
        objectEventSelected: eventFind,
      });


  };

  EmptyComponent = () => {
    return null;
  }

///Abre el Dialog con sus registros
  handleOpenDialog = (items) => {
    
  this.setState({
    openDialog: true,
    selectedEventItems: items || [],
  });
};

handleCloseDialog = () => {
  this.setState({ openDialog: false });
};






EventDay = ({ day, selectedDate, onDaySelect }) => {
  const eventsForDay = this.state.arrayNewEvents.filter((e) =>
    day.isSame(e.date, 'day')
  );
  const hasEvents = eventsForDay.length > 0;
  const isSelected = dayjs(day).isSame(dayjs(selectedDate), 'day');

  return (
    <Badge
      /* onClick={() => this.handleDateChange(day)} */
      onClick={() => {
        this.handleDateChangeBigCalendar(day);
        /* this.handleOpenDialog(this.state.selectedEventItems); */
      }

      }
      sx={{
        width: '10%',
        height: '50px',
        p: 0.9,
        m: 0.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        /* backgroundColor: isSelected ? '#004ba0' : '#f5f5f5', */
        backgroundColor: '#fff',
        color: isSelected ? '#fff' : '#000',
        /* border: isSelected ? '2px solid #fff' : 'none', */
        cursor: 'pointer',
        border: isSelected ? '2px solid #0078d4' : '1px solid #ccc',
        borderRadius: '6px',
        overflow: 'hidden',
        boxShadow: hasEvents ? 4 : 1,
        '&:hover': {
          backgroundColor: isSelected
            ? '#003c8f'
            : '#e0e0e0'
        },

        //  Responsividad: altura adaptable
        '@media (max-width: 900px)': {
          height: '65px',
        },
        '@media (max-width: 600px)': {
          height: '55px',
        },
      }}
    >
      <Box
  sx={{
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: isSelected ? '2px solid #0078d4' : 'none',
    backgroundColor: isSelected ? '#e6f2fb' : 'transparent',
    color: isSelected ? '#0078d4' : '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    transition: 'all 0.2s ease',
  }}
>
  {day.format('D')}
</Box>

<Box
  sx={{
    width: '100%',
    flexGrow: 1,
    mt: 0.5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'hidden',
  }}
>
  {eventsForDay.slice(0, 3).map((event, idx) => (
    <Typography
      key={idx}
      title={event.title}
      sx={{
        height: 15,
        backgroundColor: event.color,
        color: '#fff',
        borderRadius: '12px',
        fontSize: '0.55rem',
        mb: 0.3,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {event.title}
    </Typography>
  ))}
  {eventsForDay.length > 3 && (
    <Typography
      variant="caption"
      sx={{
        fontSize: '0.6rem',
        color: '#000',
        pl: 0.5,
      }}
    >
      +{eventsForDay.length - 3} más
    </Typography>
  )}
</Box>

    </Badge>
  );
};


render() {
  const { selectedDate, objectEventSelected, } = this.state;

  return (
    /* Contenedor general que ocupa toda la pantalla */
    <Box 
      sx={{
        height: '95vh',          
        display: 'flex',          
        flexDirection: 'column',  
      }}
    >
      {/* Contenedor que permite scroll si se desborda */}
      <Box 
        sx={{
          flexGrow: 1,            
          
          overflowX: 'auto',      
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          padding: 2,
          boxSizing: 'border-box',
        }}
      >
        {/* Calendario pequeño  */}
        <Box
          flex="1 1 320px"
          maxWidth="300px"
          boxSizing="border-box"
          sx={{
            padding: 2,
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            height: 'fit-content',
            marginBottom: { xs: 2, md: 0 },
            boxShadow: 3,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DateCalendar
              value={selectedDate}
              onChange={this.handleDateChange}
              sx={{
                width: '100%',
                height: 'auto',
                '& .MuiPickersCalendarHeader-root': {
                  justifyContent: 'flex-start',
                },
                '& .MuiPickersCalendarHeader-label': {
                  fontSize: 'calc(0.9rem + 0.3vw)',
                  fontWeight: 'bold',
                  textTransform: 'capitalize',
                  marginRight: '46px',
                },
                '& .MuiDayCalendar-day': {
                  fontSize: '0.9rem',
                  width: 36,
                  height: 36,
                },
              }}
            />
          </LocalizationProvider>


        </Box>

        {/* Calendario grande */}
        <Box
          flex="2 1 800px"
          maxWidth="1000px"
          minWidth="700px"
          width="100%"
          boxSizing="border-box"
          ml={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            padding: 2,
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            overflow: 'visible',
            alignSelf: 'flex-start',
            maxHeight: '80vh',
            overflowY: 'auto', 
            height: 'auto',
            minHeight: '500px',
            marginBottom: { xs: 2, md: 0 },
            boxShadow: 3,
            '@media (max-width: 1200px)': {
              flexDirection: 'column',
            },
            '& .MuiDayCalendar-day': {
              margin: '4px',
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DateCalendar
              value={selectedDate}
              /* onChange={() => {}}  */
              onChange={this.handleDateChangeBigCalendar}
              showDaysOutsideCurrentMonth={false}
              slots={{
                day: this.EventDay,
                leftArrowIcon: this.EmptyComponent,
                rightArrowIcon: this.EmptyComponent,
                calendarHeader: this.EmptyComponent,
              }}
              slotProps={{
                calendarHeader: { sx: { display: 'none' } },
                day: { 
                  selectedDate: selectedDate,
                  onDaySelect: this.handleDateChangeBigCalendar,
                },
              }}
              sx={{
                pointerEvents: 'auto',
                width: '100%',
                height: 'auto',
                backgroundColor: 'transparent',
                overflow: 'visible',
                '& .MuiDayCalendar-weekDayLabel': {
                  width: '14.28%',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: '#2E3B4E',
                  textTransform: 'uppercase',
                },
                '& .MuiDayCalendar-day': {
                  fontSize: 'calc(0.8rem + 0.4vw)',
                  width: '100%',
                  maxWidth: '14.28%',
                  height: '80px',
                  margin: '2px',
                },
                '& .MuiDayCalendar-slideTransition': {
                  height: 'auto',
                  overflow: 'visible',
                },
              }}
            />

        <Dialog
          disableEscapeKeyDown
          open={this.state.openDialog}
          onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            this.handleCloseDialog(event);
            }
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            elevation: 5,
            sx: {
              borderRadius: 3,
              backgroundColor: '#f9f9f9',
              maxHeight: { xs: '70vh', },
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: 'bold', bgcolor: '#0078d4', color: 'white' }}>
            Documentos del {this.state.selectedDate?.format('DD/MM/YYYY')}
          </DialogTitle>

          <DialogContent dividers>
            {this.state.selectedEventItems.length > 0 ? (
              <List dense>
                {this.state.selectedEventItems.map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: 2,
                      mb: 1,
                      boxShadow: 1,
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#0078d4', width: 32, height: 32 }}>
                        <DescriptionIcon fontSize="small" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`Nit: ${item.nit_documento}`}
                      secondary={
                        <>
                          <Typography component="span" variant="body2">
                            Total sin impuesto:{' '}
                            <strong style={{ color: '#388e3c' }}>
                              {Intl.NumberFormat('es-ES').format(item.total_sin_impuesto)}
                            </strong>
                          </Typography>
                          <br />
                          <Typography component="span" variant="body2">
                            Total con impuesto:{' '}
                            <strong style={{ color: '#f9063fff' }}>
                              {Intl.NumberFormat('es-ES').format(item.total_con_impuesto)}
                            </strong>
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="gray">
                No hay ítems para esta fecha.
              </Typography>
            )}
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'space-between' }}>
            <Typography sx={{ ml: 2, fontWeight: 'bold' }}>
              Total: {this.state.selectedEventItems.length} registro(s)
            </Typography>
            <Button onClick={this.handleCloseDialog} variant="contained" color="primary"
              sx={{
            backgroundColor: '#0078d4',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#005a9e',
            },
          }}
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>


          </LocalizationProvider>
        </Box>

          
          {/* Info del día seleccionado */}
        <Box
          flex="1 1 150px"
          minWidth="150px"
          maxWidth="100px"
          onClick={() => (this.state.selectedEventItems.length > 0)? this.handleOpenDialog(this.state.selectedEventItems): null}
          sx={{
            padding: 2,
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            height: 'fit-content',
            display: { xs: 'block', md: 'block' },
            marginTop: { xs: 2, md: 0 },
            mx: { xs: 0, md: 1 },
            boxShadow: 3,
            cursor: (this.state.selectedEventItems.length > 0)? 'pointer' : 'default',
                    '&:hover': (this.state.selectedEventItems.length > 0)? 
                     { backgroundColor: '#e0e0e0'} : 'none',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
            {selectedDate?.format('dddd, D [de] MMMM')} {/* Formato tipo "miércoles, 6 de agosto" */}
          </Typography>

          {Object.keys(objectEventSelected).length > 0 ? (
            <>
              <Typography variant="body2" gutterBottom>
                <strong>Registros:</strong> {objectEventSelected.cantidad_registros}
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Total sin impuesto:</strong> {Intl.NumberFormat('es-ES').format(objectEventSelected.total_sin_impuesto)}
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Total con impuesto:</strong> {Intl.NumberFormat('es-ES').format(objectEventSelected.total_con_impuesto)}
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Vence:</strong> {objectEventSelected.vence_documento}
              </Typography>
            </>
          ) : (
            <Typography variant="body2" color="gray">
              No hay eventos para esta fecha.
            </Typography>
          )}
        </Box>


        
      </Box>
    </Box>
  );
}
}
FormJaivana.addController('heus-calendario', CustomCalendario);
export default CustomCalendario;




